/**
 * @function CollegesColumns
 * @description
 * Genera las columnas para la tabla de colegios (CollegesTable) usada en un componente tipo `AdvanceTable`.
 * Define cómo se renderizan las columnas, incluyendo nombres, clases, estilos y acciones.
 *
 * @param {Function} handleEdit - Función para manejar la edición de un colegio (recibe el ID del colegio).
 * @param {Function} handleDelete - Función para manejar la eliminación de un colegio (recibe el ID y el nombre del colegio).
 *
 * @returns {Array<Object>} Arreglo de definiciones de columnas para una tabla avanzada.
 *
 * @example
 * const columns = CollegesColumns(handleEdit, handleDelete);
 */

import React from 'react';
import { Dropdown } from 'react-bootstrap';

import CardDropdown from 'components/common/CardDropdown';

const CollegesColumns = (handleEdit, handleDelete) => [
    {
        accessor: 'index',
        Header: '#',
        headerProps: {
            style: { width: '30px', minWidth: '30px', maxWidth: '50px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            style: { width: '30px', minWidth: '30px', maxWidth: '50px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'id', 
        Header: 'ID',
        headerProps: { className: 'hidden-column' },
        cellProps: {
              className: 'hidden-column'
        },
    },
    {
        accessor: 'name',
        Header: 'Nombre',
        headerProps: { className: 'ps-2', style: { height: '50px' } },
        cellProps: {
              className: 'white-space-nowrap pe-5 ps-2 py-2 fw-bold'
        },
    },
    { 
        accessor: 'description', 
        Header: 'Descripción',
        headerProps: { style: { minWidth: '200px' }, className: 'ps-2' },
        cellProps: { className: 'ps-2' }
    },
    { 
        accessor: 'email', 
        Header: 'Email',
        headerProps: { className: 'ps-2' },
        cellProps: { className: 'ps-2' }
    },
    { 
        accessor: 'phone', 
        Header: 'Teléfono',
        headerProps: { className: 'ps-2' },
        cellProps: { className: 'ps-2' }
    },
    { 
        accessor: 'epst', 
        Header: 'EPST',
        headerProps: {
            className: 'text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '120px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '120px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'emet', 
        Header: 'EMET',
        headerProps: {
            className: 'text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '120px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '120px' } // Establece el ancho fijo de la columna
        },
    },
    {
        accessor: 'none',
        Header: '',
        disableSortBy: true,
        headerProps: {
            style: { width: '60px', minWidth: '60px', maxWidth: '60px' }  // Ancho pequeño para el ícono del dropdown
        },
        cellProps: {
            className: 'text-end',
            style: { width: '60px', minWidth: '60px', maxWidth: '60px' }  // Ancho pequeño para el ícono del dropdown
        },
        Cell: rowData => {
            const { id, name } = rowData.row.original;
            return (
                <CardDropdown>
                      <div className="py-2">
                          <Dropdown.Item onClick={() => handleEdit(id)}>Editar</Dropdown.Item>
                          <Dropdown.Item className="text-danger" onClick={() => handleDelete(id, name)}>Eliminar</Dropdown.Item>
                      </div>
                </CardDropdown>
            );
        }
    }
];

export default CollegesColumns;